import {
  FETCH_ROOMLIST_REQUEST,
  FETCH_ROOMLIST_SUCCESS,
  FETCH_ROOMLIST_FAILURE,
} from "./roomListTypes";
import api from "../../utils/Api";
import axios from 'axios';

export const fetchRoomListRequest = () => {
  return {
    type: FETCH_ROOMLIST_REQUEST,
  };
};

export const fetchRoomListSuccess = (roomList) => {
  return {
    type: FETCH_ROOMLIST_SUCCESS,
    payload: roomList,
  };
};

export const fetchRoomListFailure = (error) => {
  return {
    type: FETCH_ROOMLIST_FAILURE,
    payload: error,
  };
};
const CancelToken = axios.CancelToken;
let cancelRequest;
export const fetchRoomList = (searchKey, sortBy, page) => {
  //cancel previous request if multiple hits done.
  cancelRequest && cancelRequest();
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  return async (dispatch) => {
    dispatch(fetchRoomListRequest);
    try {
      const response = await api.get(
        "room?search_key=" + searchKey + "&sort_by=" + sortBy + "&page=" + page,
        {
          headers: headers,
          cancelToken: new CancelToken(function executor(c) {
            cancelRequest = c;
        })
        }
      );
      const roomList = response.data.data;
      dispatch(fetchRoomListSuccess(roomList));
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Error: ', error.message); // => prints: Api is being canceled
      } 
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchRoomListFailure(errorMsg));
    }
  };
};
